// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"296":"privacy","443":"about"}[chunkId] + "." + {"296":"16c39c74","443":"2f7d806f"}[chunkId] + ".js";
};